<script setup>
import { computed } from 'vue';
import HintContainer from "@/components/alerts/HintContainer";

const props = defineProps({
  autoApprove: {
    type: Boolean,
    default: false
  },
  scoringSystemName: {
    type: String,
    default: null
  }
});

const rules = computed(() => {
  let data = [];

  // Add scoring system
  data.push({
    title: 'Scoring system',
    type: 'text',
    value: props.scoringSystemName || 'Not set',
    hint: 'The scoring system used for this box league cycle',
  });

  // Add auto approve
  data.push({
    title: 'Auto approve',
    type: 'bool',
    value: props.autoApprove,
    hint: 'Whether match results are automatically approved or require manual approval',
  });

  return data;
});
</script>

<template>
  <v-table class="rules-table">
    <tbody>
    <tr v-for="rule in rules" :key="rule.title">
      <td class="rule-title">{{ rule.title }}</td>
      <td class="text-right rule-value">
        <template v-if="rule.type === 'number' || rule.type === 'text'">
          {{ rule.value }}
        </template>
        <template v-else>
          <v-icon size="16" :color="rule.value ? 'success' : 'error'" :icon="rule.value ? 'mdi-check' : 'mdi-close'"></v-icon>
        </template>
      </td>
      <td>
        <hint-container :hint="rule.hint"></hint-container>
      </td>
    </tr>
    </tbody>
  </v-table>
</template>

<style scoped lang="scss">
td {
  padding: 10px 12px;
  font-size: 12.5px;
}

tr + tr td {
  border-top: solid 1px rgb(var(--v-theme-borderLight));
}

.rule-title {
  font-weight: 600;
  color: rgb(var(--v-theme-charcoal));
}

.rule-value {
  font-weight: 700;
  color: rgb(var(--v-theme-text));
}
</style>
